import { getLanguages } from "@/api";

const getLanguageIcon = (locale) => {
  switch (locale) {
    case "af-ZA": // South Africa
      return "za";
    case "de-DE": // Germany
      return "de";
    case "el-GR": // Greece
      return "gr";
    case "en-AU": // Australia
      return "au";
    case "en-CA": // Canada
      return "ca";
    case "en-IE": // Ireland
      return "ie";
    case "en-UK": // United Kingdom
      return "uk";
    case "en-US": // United States
      return "us";
    case "en-ZA": // South Africa
      return "za";
    case "es-ES": // Spain
      return "es";
    case "fr-BE": // Belgium
      return "be";
    case "fr-FR": // France
      return "fr";
    case "is-IS": // Iceland
      return "is";
    case "it-IT": // Italy
      return "it";
    case "ja-JP": // Japan
      return "jp";
    case "mx-MX": // Mexico
      return "mx";
    case "nl-BE": // Belgium
      return "be";
    case "pt-BR": // Brazil
      return "br";
    case "zh-CN": // China
      return "cn";
    default:
      return "us";
  }
};

export default {
  namespaced: true,
  state: () => ({
    list: [],
  }),
  mutations: {
    SET_LANGUAGES(state, languages) {
      state.list = languages;
    },
    SET_LAST_USED_LANGUAGE_ID(state, languageId) {
      localStorage.setItem("lastUsedLanguageId", languageId);
    },
  },
  actions: {
    async load({ commit }) {
      const {
        data: { rows },
      } = await getLanguages();

      commit(
        "SET_LANGUAGES",
        rows.map((language) => ({
          value: language.id,
          text: language.label,
          icon: getLanguageIcon(language.locale),
        }))
      );
    },
  },
  getters: {
    getLanguagesList: (state) => state.list,
    getLanguagesListMap: (state) =>
      state.list.reduce((acc, language) => {
        acc[language.value] = language;

        return acc;
      }, {}),
    getLastUsedLanguageId: (state) => {
      const saved = localStorage.getItem("lastUsedLanguageId");

      if (saved !== null) {
        const parsed = Number(saved);

        if (!Number.isNaN(parsed)) return parsed; // preserves 0
      }

      return state.list[0]?.value;
    },
  },
};
